// @flow

import { useCallback } from 'react';

import { type UserInputName } from '../user-input';
import { useUserInputValue } from './use-user-input-value';

type Value = boolean;
type CheckboxEvent = SyntheticInputEvent<HTMLInputElement>;
type HandleChange = (event: CheckboxEvent) => void;

export function useUserInputAsCheckbox(name: UserInputName): [Value, HandleChange] {
  const [value, setValue] = useUserInputValue(name);

  const handleChange = useCallback((event: CheckboxEvent) => {
    setValue(event.target.checked);
  }, [setValue]);

  return [value, handleChange];
}
